import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";

/* eslint-disable max-len */
export var affiliateById = function affiliateById(state) {
  return function (id) {
    return state.all.find(function (entry) {
      return entry.id === id;
    });
  };
};
export var affiliateByCategoryDesktop = function affiliateByCategoryDesktop(state) {
  return function (category) {
    return state.all.filter(function (entry) {
      return entry.categories.includes(category);
    });
  };
};
export var affiliateByCategory = function affiliateByCategory(state) {
  return function (category, index) {
    return state.all.filter(function (entry) {
      return entry.categories.includes(category);
    }).filter(function (entry, i) {
      return i % 2 === index;
    });
  };
};
export var affiliatesByFavorites = function affiliatesByFavorites(state) {
  return function (favorites, index) {
    return state.all.filter(function (entry) {
      return favorites.includes(entry.id);
    }).filter(function (entry, i) {
      return i % 2 === index;
    });
  };
};
export var populateAffiliatesLists = function populateAffiliatesLists(state) {
  return function (index) {
    return state.all.filter(function (entry, i) {
      return i % 2 === index;
    });
  };
};